import { ProductCard } from "./ProductCard";

export const FeaturedProducts = ({ products = [], onAdd }) => {
  const items = products.slice(0, 8);
  return (
    <section className="pt-2.5 pb-24 md:pb-32 bg-white" data-testid="featured-section">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="flex items-end justify-between gap-8 mb-12">
          <div>
            <div className="text-[11px] tracking-[0.3em] uppercase text-neutral-500 mb-4 font-medium">
              Featured · Best sellers
            </div>
            <h2 className="font-heading leading-[0.95] tracking-tight">
              <span className="block text-4xl md:text-6xl font-black">This week&apos;s</span>
              <span className="block text-4xl md:text-6xl font-thin">most ordered.</span>
            </h2>
          </div>
          <div className="hidden md:block max-w-xs text-sm text-neutral-600 font-light">
            Curated picks from our 90+ HA fillers, premium Korean toxins and emerging exosome formulations.
          </div>
        </div>

        {items.length === 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 border-l border-t border-neutral-200" data-testid="featured-skeleton">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="border-r border-b border-neutral-200 aspect-[3/4] bg-neutral-50 animate-pulse" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 border-l border-t border-neutral-200">
            {items.map((p) => (
              <ProductCard key={p.id} product={p} onAdd={onAdd} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
